module.exports = __webpack_public_path__ + "media/images/project/edit-b117b03738290134a630d1c59cc55941.svg";